import { render, staticRenderFns } from "./AssignmentsCardToggle.vue?vue&type=template&id=383c9bc2"
import script from "./AssignmentsCardToggle.vue?vue&type=script&lang=js"
export * from "./AssignmentsCardToggle.vue?vue&type=script&lang=js"
import style0 from "./AssignmentsCardToggle.vue?vue&type=style&index=0&id=383c9bc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QDialog});
